const basicUnits = ["bytes", "KB", "MB", "GB", "TB"] as const;
const extendedUnits = ["PB", "EB", "ZB", "YB"] as const;

const units = [...basicUnits, ...extendedUnits] as const;

type BasicUnit = (typeof basicUnits)[number];

export default function formatBytes(bytes: number) {
  if (!bytes || bytes < 0) return `0 ${units[0]}`;

  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const number = (bytes / Math.pow(k, i)).toFixed();

  return `${number.toLocaleString()} ${units[i]}`;
}

export type Size = { value: number; unit: BasicUnit };

export function bytesToUnit(value: number, unit: BasicUnit) {
  switch (unit) {
    case "KB":
      return value / Math.pow(2, 10);
    case "MB":
      return value / Math.pow(2, 20);
    case "GB":
      return value / Math.pow(2, 30);
    case "TB":
      return value / Math.pow(2, 40);
    default:
      return value;
  }
}

export function toSize(value: number, unit: BasicUnit): Size {
  return { value, unit };
}
